<template>
  <WdsStack justify-space-between class="tw-mb-6 tw-px-3">
    <WdsStack direction-column gap-sm>
      <WdsText large>
        <a :href="`/job/${jobId}`">{{ jobName }}</a>
      </WdsText>
      <WdsText secondary>
        {{ $t('Requested by :name', { name: requestedBy }) }} &#8729;
        {{ date }}
      </WdsText>
      <div>
        <WdsLabel primary subtle>{{ $t(getApprovalTriggerLabel(trigger)) }}</WdsLabel>
      </div>
    </WdsStack>
    <WdsStack align-start gap-sm>
      <WdsButton
        data-test="review-approval-button"
        sm
        :href="laravelNamedRoute('jobs.show.approvals', { job: jobId }, true)"
      >
        {{ $t('View approval') }}
      </WdsButton>
    </WdsStack>
  </WdsStack>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import {WdsStack, WdsText, WdsLabel, WdsButton} from '@worksome/wds-components'
import moment from 'moment'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import { ApprovalTrigger } from '@/gql/graphql'

const props = defineProps({
  approvable: {
    type: Object,
    required: true,
  },
})

const jobName = ref(props.approvable.approvable.job?.name ?? props.approvable.approvable.hire.job.name)
const jobId = ref(props.approvable.approvable.job?.id ?? props.approvable.approvable.hire.job.id)
const trigger = ref(props.approvable.approval.trigger)

const request = computed(() => {
  const [last] = props.approvable.approvalStates.slice(-1)
  return last
})
const requestedBy = ref(request.value?.actionedBy?.name)

const date = computed(() => {
  const d = new Date(request.value?.createdAt)
  return moment(d).fromNow() // We should replace this in the future when we remove moment
})

const getApprovalTriggerLabel = (type: string) => {
  switch (type) {
    case ApprovalTrigger.HireCreated:
      return $t('Hire Created')
    case ApprovalTrigger.HireChanged:
      return $t('Hire Changed')
    case ApprovalTrigger.ClassificationCreated:
      return $t('Classification Created')
    default:
      return $t('Unknown')
  }
}
</script>
